import { render, staticRenderFns } from "./Twofa.vue?vue&type=template&id=4b0a0115&scoped=true&"
import script from "./Twofa.vue?vue&type=script&lang=js&"
export * from "./Twofa.vue?vue&type=script&lang=js&"
import style0 from "./Twofa.vue?vue&type=style&index=0&id=4b0a0115&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0a0115",
  null
  
)

export default component.exports